import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Product, ProductFamily, GroupedProducts } from '../models/product.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ProductsService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/products`;
  private readonly familiesUrl = `${environment.apiUrl}/product-families`;

  list(): Observable<Product[]> {
    return this.http.get<Product[]>(this.apiUrl);
  }

  listGrouped(): Observable<GroupedProducts[]> {
    return this.http.get<GroupedProducts[]>(`${this.apiUrl}/grouped`);
  }

  getById(id: number): Observable<Product> {
    return this.http.get<Product>(`${this.apiUrl}/${id}`);
  }

  listFamilies(): Observable<ProductFamily[]> {
    return this.http.get<ProductFamily[]>(this.familiesUrl);
  }

  create(data: Partial<Product>): Observable<Product> {
    return this.http.post<Product>(this.apiUrl, data);
  }

  update(id: number, data: Partial<Product>): Observable<Product> {
    return this.http.patch<Product>(`${this.apiUrl}/${id}`, data);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
